import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOverseaAgentList(params) {
  return request({
    url: URL.partner.overseaAgent,
    method: 'get',
    params
  })
}

export function saveOverseaAgent(data) {
  return request({
    url: URL.partner.overseaAgent,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delOverseaAgent(uuid) {
  return request({
    url: URL.partner.overseaAgent + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

/**
 * 获取当前合作伙伴维护的换单代理
 * @param params
 * @returns {AxiosPromise}
 */
export function getExChangeAgent(params) {
  return request({
    url: URL.partner.getExChangeAgent,
    method: 'get',
    params
  })
}
